import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Box } from '../../atoms/Box';
import { Typography } from '../../atoms/Typography';

export const RoleTypography = styled(Typography)`
  padding-bottom: 20px;
`;

export const RoleBox = styled(Box)`
  width: 100%;
  border: 0px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
  margin-bottom: 10px;
  padding-top: 2px;
`;
